<template>

    <kt-modal :visible="recordVisible" :title="recordTitle" @dismiss="onDismiss()" size="modal-lg">
        <template #body>
            <mileage-form v-model="record"></mileage-form>
        </template>

        <template #footer>
            <div class="row w-100">
                <div :class="{ 'col-4': record.Id, 'col-6': !record.Id }">
                    <button @click="onDismiss()" class="btn btn-sm btn-outline-secondary form-control">Close</button>
                </div>
                <div class="col-4" v-if="record.Id">
                    <button @click="deleteRecord()" class="btn btn-sm btn-outline-danger form-control">Delete</button>
                </div>
                <div :class="{ 'col-4': record.Id, 'col-6': !record.Id }">
                    <button @click="saveRecord()" class="btn btn-sm btn-outline-primary form-control">Save</button>
                </div>
            </div>
        </template>
    </kt-modal>


</template>


<script lang="ts" setup>

import { ref, watch, onUnmounted } from "vue";
import { useRoute, useRouter } from "vue-router";
import ApiService from "@/services/ApiService";
import Helper from "@/services/Helper";
import Alert from "@/services/Alert";
import MileageForm from "@/components/Mileage/MileageForm.vue";

import Emitter from "@/services/Emitter";
import { MileageModel } from "@/models/MileageModel";

import KtModal from "@/components/UI/KtModal.vue";

const route = useRoute();
const router = useRouter();
const recordTitle = ref("Mileage Entry");
const recordVisible = ref(true);

const props = defineProps({
    requestId: {
        type: Number,
        default: 0
    },
    clientId: {
        type: Number,
        default: 0
    },
    techId: {
        type: Number,
        default: 0
    },
    embedded: {
        type: Boolean,
        default: false
    }
});

const emit = defineEmits(["cancel", "saved"]);

const unwatch:Array <Function> = [];

const newRecord = (): MileageModel => 
{
    const mileage = new MileageModel();
    // Pre-populate with context if provided
    if (props.requestId) {
        mileage.RequestId = props.requestId;
    }
    if (props.clientId) {
        mileage.CustomerNumber = props.clientId;
    }
    if (props.techId) {
        mileage.TechnicianId = props.techId;
    }
    // Set default date to today
    const today = new Date();
    const year = today.getFullYear();
    const month = String(today.getMonth() + 1).padStart(2, '0');
    const day = String(today.getDate()).padStart(2, '0');
    mileage.DateAndTime = `${year}-${month}-${day}`;
    return mileage;
};

const record = ref<MileageModel>(newRecord());

const saveRecord = async () => {

    // TODO - validate record here
    let data = Helper.prep(record.value);

    console.debug("save", data);

    data = await ApiService.saveMileage(data);

    // reload any stores you need to ...
    // ...

    if (props.embedded) {
        emit("saved");
    } else {
        // redirect ... 
        Emitter.emit("redirect", "/mileage/edit/" + data.Id);
    }
};

const deleteRecord = async () => {
    Alert.notify("Deletion is currently disabled.");
};


const onDismiss = () => {
    if (props.embedded) {
        emit("cancel");
    } else {
        Emitter.emit("redirect", "/mileage/list");
    }
};

const loadRecord = async (val:string) =>
{
    if (props.embedded && props.requestId) {
        // In embedded mode, create a new mileage for the request
        let newRec = newRecord();
        newRec.RequestId = props.requestId;
        record.value = newRec;
    } else {
        switch (val) {
            case "new":
                record.value = newRecord();
                break;

            default:
                let rec = await ApiService.loadMileage(val);
                console.debug("mileages", rec);
                record.value = rec;
                break;
        }
    }
};

if (!props.embedded) {
    unwatch.push(watch(() => [route.params.id, route.name] as const, async ([id, name]) =>
    {
        // Handle both new and edit routes
        if (!id && name === "Mileage New") {
            loadRecord("new");
        } else if (id) {
            loadRecord(id + "");
        }
    },
    {
        immediate: true
    }));
} else {
    // Load immediately in embedded mode
    loadRecord("new");
}

onUnmounted(() =>
{
    unwatch.forEach((un) =>
    {
        un();
    });
});

</script>